export const loadLazyVideo = function(videoEl: HTMLVideoElement) {
    if (videoEl.dataset.src) {
        videoEl.src = videoEl.dataset.src;
    }
    for (const source in videoEl.children) {
        const videoSource = videoEl.children[source] as HTMLSourceElement;
        if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
            videoSource.src = videoSource.dataset.src;
        }
    }

    videoEl.load();
    videoEl.classList.remove("lazy");
};
